import React, { useEffect, useState } from 'react'

import {
  Box,
  Card,
  FormControlLabel,
  Switch,
  Typography,
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'

import { NotificationEmailsCard } from '../'

import useStyles from './styles'

const CronNotificationsCard = ({
  isEdit,
  notifyOnCompleteEnabled,
  notifyOnCompleteDate,
  errors,
  setValue,
  courseId,
}) => {
  const classes = useStyles()

  const [completeEnabled, setCompleteEnabled] = useState(false)

  useEffect(() => {
    setCompleteEnabled(!!notifyOnCompleteEnabled)
  }, [notifyOnCompleteEnabled])

  const handleCompleteToggle = (event) => {
    const checked = event.target.checked
    setCompleteEnabled(checked)
    setValue('notifyOnCompleteEnabled', checked)
    if (!checked) setValue('notifyOnCompleteDate', '')
  }

  return (
    <Card className={classes.section}>
      <Typography variant="h5" className={classes.sectionTitle}>
        Notificações
      </Typography>
      <Box className={classes.emphasisColor} p={2}>
        <Box className={classes.inlineBox}>
          <Box>
            <Typography variant="body2">
              Enviar relatório diário dos alunos
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ao ativar, você receberá todos os dias às 12h um e-mail com o
              progresso dos alunos.
            </Typography>
          </Box>
          <FormControlLabel
            className={classes.switchLabel}
            control={
              <Switch
                disabled={!isEdit}
                checked={completeEnabled}
                onChange={handleCompleteToggle}
                color="primary"
              />
            }
          />
        </Box>
        {completeEnabled && (
          <KeyboardDatePicker
            disabled={!isEdit}
            className={classes.dateField}
            label="Enviar até"
            format="DD/MM/yyyy"
            value={notifyOnCompleteDate ? moment(notifyOnCompleteDate) : null}
            onChange={(date) =>
              setValue(
                'notifyOnCompleteDate',
                date?.isValid() ? date.format('YYYY-MM-DD') : '',
              )
            }
            fullWidth
            inputVariant="outlined"
            autoOk
            invalidDateMessage="Data inválida"
            error={!!errors.notifyOnCompleteDate}
            helperText={errors?.notifyOnCompleteDate?.message}
          />
        )}
      </Box>
      <NotificationEmailsCard courseId={courseId} isEdit={isEdit} />
    </Card>
  )
}

export default CronNotificationsCard
